import { useState } from 'react';
import { AgButton, AgInput } from 'src/components/ui';

import type { FilterItemProps } from './filterItemTypes';
import { findRangeBound, toStoredBound, typedBoundText } from './rangeBounds';

export default function NumberFilter({ updateFilter, filter, column, onClose }: FilterItemProps) {
  const colName = column.headerName ?? column.field;
  const [from, setFrom] = useState<string>(() => typedBoundText(column, findRangeBound(filter.where, 'gte')));
  const [to, setTo] = useState<string>(() => typedBoundText(column, findRangeBound(filter.where, 'lte')));

  return (
    <>
      <div className="flex flex-row p-2 gap-2 items-center">
        <AgInput
          size="sm"
          placeholder="Min"
          aria-label={`Minimum ${colName}`}
          className="grow"
          type="number"
          value={from}
          onChange={(val) => setFrom(val)}
        />
        <span className="text-neutral-9">to</span>
        <AgInput
          size="sm"
          placeholder="Max"
          aria-label={`Maximum ${colName}`}
          className="grow"
          type="number"
          value={to}
          onChange={(val) => setTo(val)}
        />
      </div>
      <div className="flex justify-between gap-2 p-2 border-t border-neutral-5">
        <AgButton variant="destructive-white" onPress={() => updateFilter({ field: filter.field, where: [] })}>
          Clear
        </AgButton>
        <AgButton
          variant="primary"
          onPress={() => {
            const where: FilterItemProps['filter']['where'] = [];

            const fromValue = toStoredBound(column, from);
            const toValue = toStoredBound(column, to);

            if (fromValue !== null) where.push({ gte: fromValue });
            if (toValue !== null) where.push({ lte: toValue });
            updateFilter({ field: filter.field, where });
            onClose?.();
          }}
        >
          Apply
        </AgButton>
      </div>
    </>
  );
}
